export default {
  page: {},
};



// WEBPACK FOOTER //
// ./src/app/edit-page/store/state.js